import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { Icon } from "./Icon/Icon";

type LinkButtonWithChevronProps = {
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
  to?: React.ComponentProps<typeof Scrivito.LinkTag>["to"];
  onClick?: () => void;
  "data-testid"?: string;
  params?: React.ComponentProps<typeof Scrivito.LinkTag>["params"];
};

export const LinkButtonWithChevron = Scrivito.connect(
  ({
    children,
    disabled,
    className,
    onClick,
    ...rest
  }: LinkButtonWithChevronProps) => {
    const handleClick = useCallback(() => {
      if (!disabled && onClick) {
        onClick();
      }
    }, [disabled, onClick]);

    const testedKey = (children as { _owner?: { key?: string } })?._owner?.key;

    return (
      <Scrivito.LinkTag
        data-testid={`LinkButtonWithChevron_${testedKey}-link`}
        className={cx(
          "px-4 py-3 d-flex justify-content-between align-items-center gap-2 text-nowrap text-decoration-none",
          className,
        )}
        onClick={handleClick}
        {...rest}
      >
        {children}
        <Icon
          className="d-flex align-items-center"
          iconName="chevron-right-regular"
        />
      </Scrivito.LinkTag>
    );
  },
);
